'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _Spin = require('antd/lib/spin');
var tslib_es6 = require('../../node_modules/tslib/tslib.es6.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _Spin__default = /*#__PURE__*/_interopDefaultLegacy(_Spin);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var VSpin = function (props) {
  var className = props.className,
      rest = tslib_es6.__rest(props, ["className"]);

  className = "vspin ".concat(className);
  return React__default["default"].createElement(_Spin__default["default"], tslib_es6.__assign({}, rest, {
    className: className
  }));
};

exports.VSpin = VSpin;
